import { render, staticRenderFns } from "./AddSlabsToBomModal.vue?vue&type=template&id=7ef6454f&scoped=true"
import script from "./AddSlabsToBomModal.vue?vue&type=script&lang=js"
export * from "./AddSlabsToBomModal.vue?vue&type=script&lang=js"
import style0 from "./AddSlabsToBomModal.vue?vue&type=style&index=0&id=7ef6454f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef6454f",
  null
  
)

export default component.exports